module.exports = __webpack_public_path__ + "static/img/img-mission.1238605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-mission.png
// module id = 7zZT
// module chunks = 36